import React from 'react';

const FourOhFour = () => (<h1>Oh no you found a 404!</h1>);

export default FourOhFour;



// WEBPACK FOOTER //
// ./app/components/404/index.js